import { useState } from 'react';

/**
 * A name and nothing else, because `POST /projects` accepts nothing else.
 * A project carries no ACC fields. Connecting it to Autodesk is a separate
 * step on the project's own page, once it exists.
 */
export const CreateProjectDialog = ({ isSaving, error, onCancel, onCreate }) => {
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        const trimmed = name.trim();
        if (!trimmed) {
            setNameError('Enter a project name.');
            return;
        }
        setNameError(null);
        onCreate(trimmed);
    };

    return (
        <div className="members-modal-backdrop" role="dialog" aria-modal="true" aria-label="New project">
            <form className="members-modal" onSubmit={handleSubmit}>
                <h2>New project</h2>

                <label className="pw-label" htmlFor="new-project-name">Project name</label>
                <input
                    id="new-project-name"
                    className="pw-input"
                    placeholder="e.g. Harbor Tower"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    disabled={isSaving}
                    autoFocus
                />
                {nameError && <p className="org-error">{nameError}</p>}
                {error && <p className="org-error">{error.message}</p>}

                <div className="pw-actions">
                    <button type="submit" className="rules-btn-primary" disabled={isSaving}>
                        {isSaving ? 'Creating…' : 'Create project'}
                    </button>
                    <button type="button" className="rules-btn-ghost" onClick={onCancel} disabled={isSaving}>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};
